import React from "react";
import { Button } from "react-bootstrap";

export const DatasheetCard = ({ data }) => {
  return (
    <div className="bg-white p-3 rounded-16 h-100">
      <div className="d-flex justify-content-between">
        <div>
          <h6 className="text-primary mb-2">{data.title}</h6>
          {data.time && (
            <p className="subparagraph">Time Frame : {data.time}</p>
          )}
        </div>
        <div>
          <Button
            type="button"
            variant="light"
            className="subparagraph text-muted text-nowrap"
          >
            View Report
          </Button>
        </div>
      </div>

      <div className="text-center my-5">
        <svg
          width="204"
          height="190"
          viewBox="0 0 204 190"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_572_3606)">
            <path
              d="M183 94C183 138.735 146.735 175 102 175C57.2649 175 21 138.735 21 94C21 49.2649 57.2649 13 102 13C146.735 13 183 49.2649 183 94ZM45.3 94C45.3 125.315 70.6855 150.7 102 150.7C133.315 150.7 158.7 125.315 158.7 94C158.7 62.6855 133.315 37.3 102 37.3C70.6855 37.3 45.3 62.6855 45.3 94Z"
              fill="#EEEEEE"
            />
          </g>
          <path
            d="M170.85 95C177.56 95 183.093 100.47 182.09 107.105C180.6 116.969 177.294 126.509 172.304 135.228C165.296 147.477 155.209 157.682 143.042 164.832C130.876 171.983 117.052 175.831 102.941 175.995C88.8301 176.159 74.921 172.633 62.5917 165.767C50.2624 158.901 39.9409 148.933 32.6495 136.851C25.3581 124.768 21.3498 110.991 21.0219 96.8824C20.6939 82.7741 24.0576 68.825 30.7797 56.4167C35.5649 47.5838 41.9338 39.7498 49.5345 33.2879C54.6469 28.9415 62.2105 30.7649 65.7441 36.4694V36.4694C69.2776 42.1739 67.3975 49.5843 62.5749 54.2501C58.4349 58.2556 54.9122 62.8851 52.1458 67.9917C47.4403 76.6775 45.0857 86.4419 45.3153 96.3177C45.5449 106.193 48.3506 115.838 53.4546 124.296C58.5586 132.753 65.7837 139.731 74.4142 144.537C83.0447 149.343 92.7811 151.811 102.659 151.696C112.537 151.581 122.213 148.888 130.73 143.883C139.246 138.877 146.307 131.734 151.213 123.16C154.097 118.119 156.178 112.686 157.403 107.057C158.83 100.501 164.14 95 170.85 95V95Z"
            fill="#009CD5"
          />
          <path
            d="M100.275 88.45L94 103.5H89.625L95.975 88.925H88.2V85.275H100.275V88.45ZM102.004 94.125C102.004 91.2583 102.554 89 103.654 87.35C104.771 85.7 106.562 84.875 109.029 84.875C111.496 84.875 113.279 85.7 114.379 87.35C115.496 89 116.054 91.2583 116.054 94.125C116.054 97.025 115.496 99.3 114.379 100.95C113.279 102.6 111.496 103.425 109.029 103.425C106.562 103.425 104.771 102.6 103.654 100.95C102.554 99.3 102.004 97.025 102.004 94.125ZM111.854 94.125C111.854 92.4417 111.671 91.15 111.304 90.25C110.937 89.3333 110.179 88.875 109.029 88.875C107.879 88.875 107.121 89.3333 106.754 90.25C106.387 91.15 106.204 92.4417 106.204 94.125C106.204 95.2583 106.271 96.2 106.404 96.95C106.537 97.6833 106.804 98.2833 107.204 98.75C107.621 99.2 108.229 99.425 109.029 99.425C109.829 99.425 110.429 99.2 110.829 98.75C111.246 98.2833 111.521 97.6833 111.654 96.95C111.787 96.2 111.854 95.2583 111.854 94.125Z"
            fill="black"
          />
          <defs>
            <filter
              id="filter0_d_572_3606"
              x="9"
              y="1"
              width="186"
              height="186"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feMorphology
                radius="12"
                operator="dilate"
                in="SourceAlpha"
                result="effect1_dropShadow_572_3606"
              />
              <feOffset />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_572_3606"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_572_3606"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
};
